/** Global hooks for session end → redirect to login (wired from AuthSessionBridge). */
let onUnauthorized = null;
let onSessionEnded = null;

/** Paths where 401/session expiry must not redirect to /login. */
export const PUBLIC_AUTH_PATHS = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/auth/reset-password",
  "/auth/accept-invite",
];

export function isPublicAuthPath(pathname = window.location.pathname) {
  return PUBLIC_AUTH_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/** Onboarding edits persona locally until step 2 Continue — don't overwrite from server. */
export function isOnboardingPath(pathname = window.location.pathname) {
  return pathname === "/onboarding" || pathname.startsWith("/onboarding/");
}

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

export function setSessionEndedHandler(handler) {
  onSessionEnded = handler;
}

export function notifyUnauthorized() {
  onUnauthorized?.();
}

export function notifySessionEnded() {
  onSessionEnded?.();
}
